// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CodeMirror{height:100%;font-size:small}.textArea{width:100%;min-height:400px;height:100%;resize:none;flex-grow:1;overflow:auto}", ""]);
// Exports
module.exports = exports;
